import { render, staticRenderFns } from "./ArticleManage.vue?vue&type=template&id=e8f054a6"
import script from "./ArticleManage.vue?vue&type=script&lang=ts"
export * from "./ArticleManage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports